import React from 'react';
import './Footer.css';
import footer_logo from '../Assets/logo.png';
import instagram_icon from '../Assets/instagram_icon.png';
import pinterest_icon from '../Assets/pintester_icon.png';
import whatsapp_icon from '../Assets/whatsapp_icon.png';
import { Link } from 'react-router';

const Footer = () => {
  return (
    <div className='footer'>
      <div className="footer-logo">
        <img src={footer_logo} alt="logo" />
      </div>

      <div className="footer-links">
        <a href="/docs/adatvedelmi-nyilatkozat.pdf" target="_blank" rel="noopener noreferrer">
          Adatvédelmi nyilatkozat
        </a>
        <a href="/docs/vasarlasi-feltetelek.pdf" target="_blank" rel="noopener noreferrer">
          Vásárlási feltételek
        </a>
        <Link to="/kapcsolat">Kapcsolat</Link>
      </div>

     

      <div className="footer-copyright">
        <hr />
        <p><a style={{textDecoration: 'none', color: 'black'}} href="https://nbweb.hu" target="_blank">NBWEB.</a> @ 2025 - Minden jog fenntartva</p>
      </div>
    </div>
  );
};

export default Footer;
